//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  name: 'DetailConverter',
  props: {
    data: {
      type: Object,
      default: null
    },
    tetherData: {
      type: Object,
      default: null
    },
    selectedTab: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      currencyType: this.$var.TMN,
      currencyList: [this.$var.TMN, this.$var.USDT],
      coinAmount: 1,
      tomanAmount: '0',
      validChar: [8, 9, 13, 16, 17, 18, 20, 27, 46, 91, 92, 93, 144, 188],
      convertType: this.$var.coin,
      coinPrice: this.tetherData ? this.selectedTab === 'buy' ? this.tetherData.close : this.sellDollarPrice : this.data.digital ? this.selectedTab === 'buy' ? this.data.digitalData[this.data.title + '_buy_price'] : this.data.digitalData[this.data.title + '_sell_price'] : this.data.price
    }
  },
  computed: {
    ...mapGetters({
      buyDollarPrice: 'coins/buyDollarPrice',
      sellDollarPrice: 'coins/sellDollarPrice',
      loading: 'coins/loading'
    })
  },
  watch: {
    coinAmount (val, oldVal) {
      if ((this.convertType === this.$var.coin || oldVal === 1) && this.data.symbol !== 'USDT') {
        if (this.data.digital) {
          this.tomanAmount = ((+val * +this.coinPrice))
        } else {
          this.tomanAmount = ((+val * +this.coinPrice) * (this.currencyType === this.$var.TMN ? (this.selectedTab === 'buy' ? +this.buyDollarPrice : +this.sellDollarPrice) : 1))
        }
      } else {
        this.tomanAmount = (+val * +this.coinPrice)
      }
      this.tomanAmount = Number(Number(this.tomanAmount).toFixed(0)).toLocaleString()
    },
    tomanAmount (val) {
      if (this.convertType === this.$var.TMN) {
        if (this.data.digital) {
          this.coinAmount = (val.includes(',') ? this.$coinNumber(((Number(val.split(',').join('')) / this.data.digitalData[this.data.title + '_buy_price']))) : this.$coinNumber(((Number(val) / this.data.digitalData[this.data.title + '_buy_price']))))
        } else {
          this.coinAmount = (val.includes(',') ? this.$coinNumber(((Number(val.split(',').join('')) / (this.currencyType === this.$var.TMN ? +this.buyDollarPrice : 1)) / +this.data.price)) : this.$coinNumber(((+val / +this.buyDollarPrice) / +this.data.price)))
        }
        const result = val.replace(/\D/g, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',')
        // eslint-disable-next-line no-return-assign
        this.$nextTick(() => this.tomanAmount = result)
      }
    },
    'loading.usdtPrice' (val) {
      if (!val) {
        this.tomanAmount = (+this.data.price * (this.currencyType === this.$var.TMN ? +this.buyDollarPrice : 1)).toLocaleString()
      }
    },
    currencyType (val) {
      this.tomanAmount = (+this.data.price * (val === this.$var.TMN ? +this.buyDollarPrice : 1)).toLocaleString()
    },
    selectedTab (val) {
      this.tomanAmount = (+this.coinAmount * (this.tetherData ? this.selectedTab === 'buy' ? this.tetherData.close : this.sellDollarPrice : this.data.digital ? this.selectedTab === 'buy' ? this.data.digitalData[this.data.title + '_buy_price'] : this.data.digitalData[this.data.title + '_sell_price'] : this.data.price * (this.selectedTab === 'buy' ? +this.buyDollarPrice : +this.sellDollarPrice)))
      this.tomanAmount = Number(Number(this.tomanAmount).toFixed(0)).toLocaleString()
    }
  },
  created () {
    if (this.data.symbol !== 'USDT') {
      if (this.data.digital) {
        this.tomanAmount = ((+this.coinAmount * +this.coinPrice))
      } else {
        this.tomanAmount = ((+this.coinAmount * +this.coinPrice) * (this.currencyType === this.$var.TMN ? +this.buyDollarPrice : 1))
      }
    } else {
      this.tomanAmount = (+this.coinAmount * +this.coinPrice)
    }
    this.tomanAmount = Number(Number(this.tomanAmount).toFixed(0)).toLocaleString()
  },
  methods: {
    checkValidChar (code) {
      const index = this.validChar.findIndex(i => i === code)
      return index >= 0
    },
    isNumber (evt) {
      this.convertType = this.$var.TMN
      const charCode = evt.which ? evt.which : evt.keyCode
      if ((charCode >= 33 && charCode <= 40) || (charCode >= 48 && charCode <= 57) || (charCode >= 96 && charCode <= 105) || this.checkValidChar(charCode) || ((evt.shiftKey || evt.metaKey) && (charCode === 65 || charCode === 67 || charCode === 86))) {
        return true
      } else {
        evt.preventDefault()
      }
    }
  }
}
